import { useCallback } from 'react';

import type { NotificationType } from '../notify';
import { notify } from '../notify';

export const useNotification = () =>
  useCallback((notification: NotificationType) => {
    notify(notification);
  }, []);
